<template>
    <AdaptersDialog
        :listener-id="listenerOpen"
        :listener-close-id="listenerClose"
        :header="$t('lang.wordstat.report.delete_words')"
        :loading="loading"
        :callback-agree="onDeleteFromFile"
        :button-agree-label="$t('lang.main.btn.delete')"
        :callback-on-hide="onHide"
        :is-disable-send="isDisabledSend"
    >
        <template #content>
            <div v-if="isDisabledSend" class="grid">
                <div  class="col-12">
                    <TemplatesDisabledParentProjectsMessage
                        :clusterUid="clusterUid"
                        :clusterName="clusterName"
                        :monitoringId="monitoringId"
                        :monitoringName="monitoringName"
                    />
                </div>
            </div>
            <div v-else class="grid">
                <div class="col-12">
                    <div class="flex flex-column md:flex-row gap-3">
                        <div class="flex-order-2 md:flex-order-1">
                            <AdaptersFileUpload
                                mode="basic"
                                @select="selectFile"
                                :pt="{chooseButton: {class: 'p-button-sm p-button-secondary white-space-nowrap'}}"
                                :chooseLabel="$t('lang.wordstat.report.button_select_file')"
                                accept=".txt, .csv"
                            />
                        </div>
                        <div class="flex-order-1 md:flex-order-2">
                            <p class="p-0 m-0 text-xs text-gray-500" v-html="$t('lang.wordstat.sample_files')"></p>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="field">
                        <TemplatesLabelCounts
                            :text="$t('lang.wordstat.report.delete_from_area_label')"
                            :count="getCount"
                        />
                        <Textarea v-model="list" :rows="6" />
                    </div>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>

<script>
import AdaptersDialog from "../../../component/adapters/Dialog.vue";
import TemplatesLabelCounts from "../../../templates/LabelCounts.vue";
import Textarea from "primevue/textarea";
import AdaptersFileUpload from "../../../component/adapters/FileUpload.vue";
import {RowsHelper} from "../../../helpers/RowsHelper";
import {Listeners} from "../../../constants/listeners";
import WordstatApi from "../../../api/WordstatApi";
import TemplatesDisabledParentProjectsMessage from "../../../templates/DisabledParentProjectsMessage.vue";
import WordstatImportFromArea from "./ImportFromArea.vue";

export default {
    name: "WordstaDeleteFromArea",
    props: {
        id: {
            type: Number,
            required: true,
        },
        clusterUid: {
            type: String,
            required: false,
            default: null,
        },
        clusterName: {
            type: String,
            required: false,
            default: null,
        },
        monitoringId: {
            type: Number,
            required: false,
            default: null,
        },
        monitoringName: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            list: null,
            listenerOpen: Listeners.WORDSTAT_POPUP_DELETE_FROM_AREA_OPEN,
            listenerClose: Listeners.WORDSTAT_POPUP_DELETE_FROM_AREA_CLOSE,
            loading: false,
        }
    },
    computed: {
        getCount() {
            return RowsHelper.getCountFromString(this.list);
        },
        isDisabledSend() {
            return !!(this.clusterUid || this.monitoringId);
        },
    },
    methods: {
        onDeleteFromFile() {
            this.loading = true;
            WordstatApi
                .deleteWords({projectId: this.id, words: RowsHelper.getArrayFromString(this.list)})
                .then(() => {
                    this.$emitter.emit(this.listenerClose);
                    this.$emitter.emit(Listeners.KS_FILTER_REFRESH);
                })
                .catch(error => this.alertError(error))
                .finally(() => this.loading = false);

        },
        selectFile(input) {
            const file = input.files.shift();
            const reader = new FileReader();
            const extension = file.name.split('.').pop().toLowerCase();

            reader.onload = event => {
                switch (extension) {
                    case 'txt':
                        this.list = event.target.result;
                        break;
                    case 'csv':
                        this.list = RowsHelper.getStringFromCsv(event.target.result);
                        break;
                }
            }
            reader.readAsText(file);
        },
        onHide() {
            this.list = '';
        }
    },
    components: {
        WordstatImportFromArea,
        TemplatesDisabledParentProjectsMessage,
        AdaptersFileUpload,
        Textarea,
        TemplatesLabelCounts,
        AdaptersDialog,
    }
}
</script>
